var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonochromeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 83",
    width: 83,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.47 75.212C75.903 67.679 82.7 55.386 82.7 41.5 82.7 18.58 64.185 0 41.35 0 18.513 0 0 18.58 0 41.5c0 14.154 7.06 26.653 17.84 34.144a41.324 41.324 0 003.244 2.038c1.95 1.212 4.686 2.463 7.955 3.448A41.199 41.199 0 0041.59 83h.082c2.52 0 4.945-.26 7.221-.689a40.93 40.93 0 006.853-1.895c3.13-1.15 5.674-2.497 7.37-3.624a41.42 41.42 0 002.35-1.577l.038 1.285s-.018-.726-.034-1.288zm-.023-.603l.018.606.004-.003c-.012-.43-.022-.764-.022-.603zm0 0c0-3.291-1.804-6.623-4.747-8.094l-10.348-5.173a3.947 3.947 0 01-2.181-3.53v-4.06c.29-.331.623-.757.979-1.26a23.79 23.79 0 003.216-6.482c1.327-.408 2.304-1.634 2.304-3.091v-4.333a3.23 3.23 0 00-1.083-2.402V29.92s1.286-9.75-11.916-9.75c-13.203 0-11.916 9.75-11.916 9.75v6.264a3.231 3.231 0 00-1.083 2.402v4.333c0 1.141.6 2.146 1.498 2.726 1.082 4.714 3.918 8.106 3.918 8.106v3.96a3.945 3.945 0 01-2.057 3.464l-9.664 5.272a8.687 8.687 0 00-4.528 7.627v.26c0 .829 1.182 2.066 3.245 3.348a41.04 41.04 0 007.955 3.448A44.194 44.194 0 0041.59 83a41.417 41.417 0 007.303-.689 43.042 43.042 0 006.853-1.895 41.12 41.12 0 007.37-3.624c1.495-.993 2.332-1.816 2.332-2.183z",
    fill: "var(--color-secondary-light)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonochromeUser);
export default __webpack_public_path__ + "static/media/monochrome-user.b9c5c435b9b5e70b7dcc74cb70e78bf1.svg";
export { ForwardRef as ReactComponent };